(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('eccezioni', {
                parent: 'entity',
                url: '/eccezionis',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                    pageTitle: 'uniromaLandingApp.eccezioni.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/eccezioni/eccezionis.html',
                        controller: 'EccezioniController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('eccezioni');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('eccezioni.detail', {
                parent: 'entity',
                url: '/eccezioni/{id}',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                    pageTitle: 'uniromaLandingApp.eccezioni.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/eccezioni/eccezioni-detail.html',
                        controller: 'EccezioniDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('eccezioni');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Eccezioni', function($stateParams, Eccezioni) {
                        return Eccezioni.get({id : $stateParams.id});
                    }]
                }
            })
            .state('eccezioni.new', {
                parent: 'eccezioni',
                url: '/new',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/eccezioni/eccezioni-dialog.html',
                        controller: 'EccezioniDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    codFis: null,
                                    fonte: 'UGOV',
                                    username: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('eccezioni', null, { reload: true });
                    }, function() {
                        $state.go('eccezioni');
                    })
                }]
            })
            .state('eccezioni.edit', {
                parent: 'eccezioni',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_GESTIONE_ECCEZIONI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/eccezioni/eccezioni-dialog.html',
                        controller: 'EccezioniDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Eccezioni', function(Eccezioni) {
                                return Eccezioni.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('eccezioni', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }
})();
